<script lang="ts" setup>
const { locale } = useI18n()
import { getPersonBySlug } from '~/queries/composer'
const { formatToFullDate } = useFullDateFormater()
const handleHtmlClick = useHandleHtmlClick()
const { slug } = useResourceSlug()
const { data, pending, error } = await useAsyncData(`/person/${slug}`, () =>
  execQuery(getPersonBySlug, {
    slug,
  })
)
const composer = computed<Composer>(() => {
  if (pending.value || error.value) return null
  return data.value.data.personBySlug
})
const resources = computed<Composer>(() => {
  if (!composer.value) return null
  return composer.value.resources
})
</script>
<template>
  <DetailComposer
    :resume="
      locale === 'fr'
        ? composer?.resume
        : composer?.resumeEn ?? composer?.resume
    "
    :composer="composer"
    :active-outline-id="'resources'"
  >
    <template #typeIcon>
      <div
        class="m-14 hidden h-40 w-40 shrink-0 items-center justify-center bg-white sm:flex lg:h-60 lg:w-60"
        v-if="composer?.photo?.getUrl"
      >
        <div class="relative">
          <img
            :src="composer?.photo?.getUrl"
            :alt="
              'biography of ' + composer?.firstName + ' ' + composer?.lastName
            "
            class="h-full w-full object-cover sm:p-0"
          />
          <span
            v-if="composer?.copyrights"
            class="absolute right-1 bottom-0 text-white"
            >© {{ composer?.copyrights }}</span
          >
        </div>
      </div>
    </template>
    <template #prose="{ classes }">
      <div
        :class="classes"
        class="mt-4 text-justify"
        v-html="resources"
        @click="handleHtmlClick"
      />
    </template>

    <div v-if="composer.documents">
      <h4 class="text-lg font-semibold my-2">Documents</h4>
      <ul class="list-disc px-6 text-lg">
        <li v-for="document in composer.documents">
          <BasicLink
            :key="`${document.title}`"
            :to="`/numericDocument/${document.slug}`"
          >
            {{ document.title }}
          </BasicLink>
          <span v-if="document.publishingStartDate"
            >, le {{ formatToFullDate(document.publishingStartDate) }}.</span
          >
        </li>
      </ul>
    </div>
  </DetailComposer>
</template>
